// Pathfinder Unchained Variant Multiclassing — Druid archetype benefit tiers.
const druidArchetype = [
  {
    level: 1,
    name: 'Druidic Code',
    description: 'You gain Druidic as a bonus language and must abide by the druidic code of conduct—respecting nature, not teaching the Druidic language to outsiders, not wearing metal armor, and so on.',
  },
  {
    level: 3,
    name: 'Wild Empathy',
    description: 'You gain wild empathy, treating your character level as your effective druid level.',
  },
  {
    level: 7,
    name: 'Animal Companion',
    description: 'You gain an animal companion as a druid of your character level – 4. No ability other than Improved Companion can ever increase your effective druid level for this purpose.',
  },
  {
    level: 11,
    name: 'Improved Companion',
    description: 'Your animal companion increases to that of a druid of your full character level.',
  },
  {
    level: 15,
    name: 'Wild Shape',
    description: 'You gain the ability to use wild shape to turn into a Small or Medium animal two times per day for up to 1 hour per character level each time.',
  },
  {
    level: 19,
    name: 'Greater Wild Shape',
    description: 'Your wild shape improves to include the 6th-level druid options, and you can use wild shape three times per day.',
  },
];

export default druidArchetype;
